import { isBefore, isAfter, format } from 'date-fns'

type OrderNotificationType = {
  number: string
  status: string
  cancelled: boolean
  delivery: string
  shipping: string
  dateFulfilled: string
}

export type OrderNotificationsType = Array<OrderNotificationType>

const replaceHyphensWithSlashes = (date: string) => {
  // Addresses problem where date-fns
  // returns one day previous value when date is represented using hyphens
  // Source: https://stackoverflow.com/questions/68807970/parse-function-in-date-fns-returns-one-day-previous-value
  return date.replace(/-/g, '/')
}

const findEligibleDeliveryDates = (orderNotifications: OrderNotificationsType): string[] => {
  return orderNotifications
    .map((orderNotification) => {
      orderNotification.delivery = replaceHyphensWithSlashes(orderNotification.delivery)
      if (isBefore(orderNotification.delivery, Date.now())) {
        return
      }
      if (orderNotification.cancelled) {
        return
      }
      return orderNotification.delivery
    })
    .filter((date) => date)
}

const sortDatesInAscendingOrder = (dates: string[]) => {
  return dates.sort((date1, date2) => {
    if (isAfter(date1, date2)) {
      return 1
    }
    if (isBefore(date1, date2)) {
      return -1
    }
  })
}

const formatDateString = (date: string) => {
  return format(date, 'eee MM/dd')
}

export const findUpcomingDeliveryDates = (orderNotifications: OrderNotificationsType) => {
  const eligibleDeliveryDates = findEligibleDeliveryDates(orderNotifications)
  const deliveryDatesAscendingOrder = sortDatesInAscendingOrder(eligibleDeliveryDates)
  return deliveryDatesAscendingOrder.map((date) => formatDateString(date))
}
